/* unplugin-vue-components disabled */import { render } from "./Content.vue?vue&type=template&id=0d72a1c0&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=0d72a1c0&lang=scss&scoped=true"

import exportComponent from "/data/repos/231_20260522130100/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d72a1c0"]])

export default __exports__